export enum WebMessageType {
	Contact = "Contact",
	ContactThroughModal = "ContactThroughModal",
	ProductDemand = "ProductDemand",
}
